import { ContentSyncCoordinator, type ContentSyncConfig, type SyncPassResult } from "./content-sync";
import { articles } from "@/services/cache";
import { articlesSyncKey } from "@/types/products/product-keys";
import type { ContentfulArticle, NormalizedContent } from "@tmi/types/entities";
import type { Articles } from "@tmi/types/api/content-models";

import { createDefaultLogger, LogLevels } from "@/types/console-logger";
const logger = createDefaultLogger( LogLevels.DEBUG );

const config: ContentSyncConfig<Articles, ContentfulArticle> = {
    name: 'articles',
    store: () => articles,
    syncKey: articlesSyncKey,
    metaRoute: 'content/articles-catalog-meta',
    contentRoute: 'content/articles-catalog',
    contentPageSize: 350,
    metaContentFilter: { fromPublishedDateTimeUTC: '2008-01-01' },
    extractMetaPayload: ( data ) => data.articlesCatalog?.articles,
    extractContentPayload: ( data ) => data.articlesCatalog?.articles,
    normalizeItem: normalizeArticle
};

export class ArticlesSyncCoordinator {
    readonly #inner: ContentSyncCoordinator<Articles, ContentfulArticle>;
    constructor() {
        this.#inner = new ContentSyncCoordinator( config );
    }
    patchRepository( authToken: string, force: boolean = false ): Promise<SyncPassResult> {
        return this.#inner.patchRepository( authToken, force );
    }
}

export function normalizeArticle( article: ContentfulArticle ): NormalizedContent | undefined {
    try {
        return {
            contentfulId: article.id,
            publishedDate: article.publish_dt,
            updatedDate: article.publish_at,
            slug: article.slug ?? undefined,
            title: article.title ?? undefined,
            text: article.body ?? undefined,
            body2: article.body2 ?? undefined,
            preview: article.preview ?? undefined,
            thumbnail: article.thumbnail_uri ?? undefined,
            editorialAd: article.editorial_ad ?? undefined,
            videoLink: null === article.video_id ? undefined : `https://vimeo.com/${ article.video_id }`,
            authorId: article.author_id,
            adProductId: article.ad_product_id,
            categoryIds: article.assoc_category_ids ?? [],
            productIds: article.assoc_product_ids ?? [],
            sectorIds: article.assoc_sector_ids ?? [],
            tickerIds: article.assoc_ticker_ids ?? []
        };
    } catch ( e: any ) {
        logger.error( `[ articles-sync-coordinator ] Failed to normalize article '${ article.id }':`, e );
        return undefined;
    }
}
